import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchStatisticsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchStatistics: FC<SrWidgetMatchStatisticsProps> = ({ matchId, ...props }) => {
    const widgetProps = { matchId: matchId, disableWidgetHeader: true, disableMatchHeader: true };
    return <SrWidget widgetName="match.statistics" widgetProps={widgetProps} {...props} />;
};
